/** Pendant zu `Services/API/ApiRechnungszuordnungService.cs`. */

import type { ReceiptAssignment } from '@/types/entities';
import { EntityTypes } from '@/types/enums';

import { buildAppPath } from '../apiBase';
import { createViewApi, type ViewApi } from '../apiViewBase';
import { apiClient } from '../httpClient';

export const receiptAssignmentApi: ViewApi<ReceiptAssignment> & {
  recalc(viewId: number, containerId: number): Promise<void>;
} = {
  ...createViewApi<ReceiptAssignment>('rechnungszuordnungen', EntityTypes.Rechnungszuordnung),

  /**
   * Ruft den Container-Endpunkt auf und verschluckt jeden Fehler — im Altclient sind sowohl
   * die Statusprüfung als auch der Wurf auskommentiert.
   */
  async recalc(viewId, containerId) {
    try {
      await apiClient.raw('POST', `${buildAppPath('container')}/${viewId}/${containerId}/recalc`);
    } catch {
      return;
    }
  },
};
